import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/main.scss';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './_redux/store';
import 'antd/dist/reset.css';
import './index.css';
import { AuthProvider } from './_hooks/useAuthContext';

const Root = () => {
  return (
    <React.StrictMode>
        <Provider store={store}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </Provider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
